import { render } from "./EconomyEvaluationUpload.vue?vue&type=template&id=67baff44"
import script from "./EconomyEvaluationUpload.vue?vue&type=script&lang=js"
export * from "./EconomyEvaluationUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__